import { AllUserRoles } from "app/shared/generic_variables";
import { VillageGroup, VillageType } from "common/typings";

export const environment = {
  production: true,
  firebase: {
    apiKey: "AIzaSyBcmdIfh2VCvUsPJBXrTEiUPkY3qyU_L2k",
    authDomain: "marinavillage-1.firebaseapp.com",
    databaseURL: "https://marinavillage-1.firebaseio.com",
    projectId: "marinavillage-1",
    storageBucket: "marinavillage-1.appspot.com",
    messagingSenderId: "1083635958124",
    appId: "1:1083635958124:web:18025952b916579d427349",
    measurementId: "G-YSSGC521EB",
  },
  apiEndPoint: "https://us-central1-marinavillage-1.cloudfunctions.net",
  frontendUrl: "https://marinavillage-1.web.app",
};

export const appName = "MarinaVillage Prod";

export const Roles = [
  AllUserRoles.admin,
  AllUserRoles.maintenance,
  AllUserRoles.security,
  AllUserRoles.boater,
  AllUserRoles.vendor,
  AllUserRoles.vendor_employee,
  AllUserRoles.pdFireEms,
  AllUserRoles.district,
];

export const strings = {
  appName: "MarinaVillage",
  villageType: VillageType.MARINA,
  villageGroup: VillageGroup.Harbor,
};

export const AllAlerts = [
  {
    key: "medical",
    value: "Medical",
    title: "A MEDICAL EMERGENCY has been reported",
  },
  {
    key: "armed",
    value: "Armed Assailant",
    title: "An ARMED ASSAILANT has been reported",
  },
  {
    key: "fight",
    value: "Fight",
    title: "A FIGHT has been reported",
  },
  {
    key: "fire",
    value: "Fire",
    title: "A FIRE has been reported",
  },
  {
    key: "intruder",
    value: "Intruder",
    title: "An INTRUDER has been reported",
  },
  {
    key: "other",
    value: "Other",
    title: "An EMERGENCY has been reported",
  },
  {
    key: "incident",
    value: "Incident",
    title: "An INCIDENT has been reported",
  },
  {
    key: "auto",
    value: "Auto",
    title: "An AUTO ACCIDENT/INJURY has been reported",
  },
  {
    key: "boat",
    value: "Boat",
    title: "A BOAT ACCIDENT/INJURY has been reported",
  },
  {
    key: "explosion",
    value: "Explosion",
    title: "An EXPLOSION has been reported",
  },
];
export const UserBulkUploadFileSampleTemplateFileName = "mv-user-bulk-upload-sample.xlsx";
